// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xy x2","wrapperNeonRental":"xz x3","addMyListButton":"xA ya","upperParts":"xB"};